/**
 * The sticky top offset shared by the results table controllers.
 *
 * Extracted from `TableController` in WFW-6748 so the single-table controller
 * sticks to exactly the same place. The offset has to clear whatever sits
 * above it: the top ad and the visible header, plus — on small devices — the
 * persistent search bar, whose height is treated as the static 68px it is
 * rather than measured on every scroll.
 */

/** Height of the mobile persistent search bar, in px. */
export const PERSISTENT_SEARCH_HEIGHT = 68;

/** Height of the results table controller, in px. */
export const RESULTS_CONTROLLER_HEIGHT = {
	small: 52,
	large: 38,
};

/**
 * Each sticky layer sits 1px under the one above it, so the seam between them
 * never shows as a hairline gap while scrolling.
 */
export const STICKY_TUCK = 1;

export default {
	computed: {
		topAdHeight() {
			return this.isSmallDevice
				? PERSISTENT_SEARCH_HEIGHT
				: this.$store.state.window.topAdHeight;
		},
		isPersistentSearch() {
			return this.$store.getters["navigation/isPersistentSearch"];
		},
		stickyTopOffset() {
			const HEADER_BORDER =
				this.isSmallDevice || this.isPersistentSearch ? -1 : 0;
			const OFFSET =
				this.topAdHeight +
				this.$store.state.window.visibleHeaderHeight +
				HEADER_BORDER;

			return {
				top: `${OFFSET}px`,
			};
		},
	},
};
